import React from 'react';

const SvgCd = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CD_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CD_svg__b" fill="#fff">
        <use xlinkHref="#CD_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CD_svg__a" />
      <rect
        fill="#158AFF"
        mask="url(#CD_svg__b)"
        width={28}
        height={20}
        rx={2}
      />
      <path
        fill="#FDD216"
        mask="url(#CD_svg__b)"
        transform="rotate(153 13.317 10.418)"
        d="M-6.016 6.418H32.65v8H-6.016z"
      />
      <path
        fill="#CE1120"
        mask="url(#CD_svg__b)"
        transform="rotate(153 13.685 10.175)"
        d="M-5.648 7.508h38.666v5.334H-5.648z"
      />
      <path
        fill="#FDD216"
        mask="url(#CD_svg__b)"
        d="M4.667 5.967l-1.96 1.396.723-2.295-1.934-1.431 2.407-.022.764-2.282.764 2.282 2.406.022-1.934 1.431.723 2.295z"
      />
    </g>
  </svg>
);

export default SvgCd;
